import { ChevronLeft, ChevronRight } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Button_Names } from "@/constants/global-constants";
import { cn } from "@/lib/utils";

type TFooterProps = {
  disableBack?: boolean;
  step: number;
  isLoading: boolean;
  isSuccess: boolean;
  setActiveTab: SetState<string>;
  isActive?: boolean;
  operationType?: "edit" | "add";
  reset: () => void;
};

const StepFooter: React.FC<TFooterProps> = ({
  disableBack = false,
  step,
  isLoading,
  isSuccess,
  setActiveTab,
  isActive,
  operationType,
  reset,
}) => {
  if (isSuccess && step !== 2) {
    setActiveTab((step + 1).toString());
  }
  const handleBackClick = (): void => {
    if (step !== 1) {
      setActiveTab((step - 1).toString());
    }
  };

  return (
    <section className='flex items-center justify-between mt-16'>
      <Button
        disabled={disableBack}
        variant={"ghost"}
        onClick={handleBackClick}
        className={cn(step === 1 && "invisible")}
      >
        <ChevronLeft />
        Back
      </Button>
      <p>{step}/2 Steps</p>
      <div className='flex items-center gap-2'>
        <Button
          className='rounded-sm'
          size={"lg"}
          type='reset'
          variant={"ghost"}
          onClick={() => reset()}
        >
          {operationType === "add"
            ? Button_Names.Reset
            : Button_Names.Discard_Change}
        </Button>
        <Button disabled={isActive} isLoading={isLoading} type='submit'>
          {step === 2 ? Button_Names.Submit : Button_Names.Next}
          <ChevronRight />
        </Button>
      </div>
    </section>
  );
};

export default StepFooter;
